var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternationalBannerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 167 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.211853 88.748C36.0628 88.748 52.4371 36.2084 94.7228 41.3133C107.42 42.8619 126.612 15.5166 135.987 5.82741C145.362 -3.86177 166.992 -1.80784 166.992 14.5468C166.992 30.9014 166.992 88.748 166.992 88.748H0.211853Z",
    fill: "url(#paint0_linear_696_17373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.914 89.1411V24.6593C106.914 23.7565 106.162 23.0042 105.259 23.0042C104.356 23.0042 103.604 23.7565 103.604 24.6593V89.1411H106.914Z",
    fill: "url(#paint1_linear_696_17373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.259 36.9976C105.349 36.9976 105.44 36.9976 105.53 36.9675C106.433 36.817 107.035 35.9744 106.884 35.0716C106.132 30.6178 102.159 27.4881 97.6455 27.8192C96.7427 27.8793 96.0505 28.6919 96.1107 29.5947C96.1709 30.4974 96.9834 31.1896 97.8862 31.1294C100.685 30.9187 103.153 32.8447 103.634 35.6133C103.754 36.4258 104.477 36.9976 105.259 36.9976Z",
    fill: "#CAE6C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.259 36.9975C106.042 36.9975 106.764 36.4257 106.884 35.6132C107.336 32.8447 109.803 30.9187 112.632 31.1294C113.535 31.1895 114.347 30.5275 114.407 29.5946C114.468 28.6918 113.806 27.8793 112.873 27.8191C108.329 27.4881 104.356 30.5877 103.634 35.0715C103.484 35.9743 104.085 36.817 104.988 36.9674C105.079 36.9975 105.169 36.9975 105.259 36.9975Z",
    fill: "#CAE6C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.259 45.3032C105.349 45.3032 105.44 45.3032 105.53 45.2732C106.433 45.1227 107.035 44.2801 106.884 43.3773C106.132 38.9235 102.159 35.7938 97.6455 36.1248C96.7427 36.185 96.0505 36.9975 96.1107 37.9003C96.1709 38.8031 96.9834 39.4953 97.8862 39.4351C100.685 39.2244 103.153 41.1504 103.634 43.919C103.754 44.7315 104.477 45.3032 105.259 45.3032Z",
    fill: "#CAE6C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.259 45.3032C106.042 45.3032 106.764 44.7314 106.884 43.9189C107.336 41.1503 109.803 39.2244 112.632 39.435C113.535 39.4952 114.347 38.8332 114.407 37.9003C114.468 36.9975 113.806 36.185 112.873 36.1248C108.359 35.7938 104.356 38.8934 103.634 43.3772C103.484 44.28 104.085 45.1226 104.988 45.2731C105.079 45.3032 105.169 45.3032 105.259 45.3032Z",
    fill: "#CAE6C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_17373",
    x1: 81.3075,
    y1: 14.154,
    x2: 81.3075,
    y2: 85.7565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEFFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_696_17373",
    x1: 105.259,
    y1: 23.0042,
    x2: 105.259,
    y2: 82.7391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#CAE6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4772,
    stopColor: "#CDE7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6541,
    stopColor: "#D6ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    stopColor: "#E5F3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9698,
    stopColor: "#FBFDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalBannerRight);
export default __webpack_public_path__ + "static/media/international-banner-right.b077294b.svg";
export { ForwardRef as ReactComponent };